export const SUBSCRIPTION_LAYOUTS = ['Concrete', 'Minimalist', 'LoginlessFlat', 'LoginlessGrouped', 'Lavish'];
export const LOGINLESS_LAYOUTS = ['LoginlessFlat', 'LoginlessGrouped'];
export const STANDARD_SUBSCRIPTION_LAYOUTS = ['Concrete', 'Minimalist', 'Lavish'];

export const DEFAULT_LOGINLESS_SETTINGS: Record<string, any> = {
  pageTitle: 'Upgrade to Premium',
  planSelectionHeading: 'Select Your Plan',
  orderSummaryHeading: 'Order Summary',
  toPayLabel: 'To Pay',
  taxNote: '',
  descriptionTitle: "What's Included",
  showOfferPrice: true,
  loaderMessage: 'Oops, it seems plans are taking longer than expected to load. Thank you for your patience!',
  thankYouPageTitle: 'Subscription Successful',
  thankYouPageDescription:
    'Your subscription is active. Just log in or create your account to start enjoying your premium content.',
  continueReading: 'Continue to Sign In / Sign Up'
};

export const DEFAULT_STANDARD_SETTINGS: Record<string, string> = {
  pageTitle: 'Discover the Power of News Subscription Plans',
  pageDescription:
    'Unlock premium news content and stay informed with our exclusive subscription plan. Get access to in-depth stories and expert analysis.',
  subscribeButton: 'Subscribe Now',
  descriptionTitle: "What's Included",
  loaderMessage: 'Oops, it seems plans are taking longer than expected to load. Thank you for your patience!',
  thankYouPageTitle: 'Thank you for placing your order!',
  thankYouPageDescription:
    'We kindly ask for your patience as we process it (approx. 15min). Please check your email for further details and updates.',
  continueReading: 'Continue Reading',
  goToProfile: 'Go to Profile',
  goToHome: 'Go to Home'
};

export const buildEffectiveSubscription = (rawSubscription: Record<string, any>, isLoginlessEnabled: boolean) => {
  const rawPageSetting: Record<string, any> = rawSubscription.pageSetting || {};
  const defaults = isLoginlessEnabled ? DEFAULT_LOGINLESS_SETTINGS : DEFAULT_STANDARD_SETTINGS;

  const effectivePageSetting: Record<string, any> = { ...defaults };

  Object.keys(rawPageSetting).forEach(key => {
    const val = rawPageSetting[key];
    // Preserve booleans (false is valid); skip only empty strings, null, undefined
    if (typeof val === 'boolean' || (val !== undefined && val !== null && val !== '')) {
      effectivePageSetting[key] = val;
    }
  });

  return { ...rawSubscription, pageSetting: effectivePageSetting };
};

export const getLoginlessSettings = () => [
  {
    label: 'Page Title',
    type: 'quillEditor',
    defaultValue: 'Upgrade to Premium',
    key: 'pageTitle',
    placeHolder: 'Upgrade to Premium'
  },
  {
    label: 'Select Your Plan',
    placeHolder: 'Select Your Plan',
    key: 'planSelectionHeading',
    defaultValue: 'Select Your Plan',
    type: 'textField'
  },
  {
    label: 'Order Summary',
    placeHolder: 'Order Summary',
    key: 'orderSummaryHeading',
    defaultValue: 'Order Summary',
    type: 'textField'
  },
  {
    label: 'To Pay',
    placeHolder: 'To Pay',
    key: 'toPayLabel',
    defaultValue: 'To Pay',
    type: 'textField'
  },
  {
    label: 'Inclusive of all taxes',
    placeHolder: 'Inclusive of all taxes',
    key: 'taxNote',
    defaultValue: 'Inclusive of all taxes',
    type: 'textField'
  },
  {
    label: "What's Included",
    placeHolder: "What's Included",
    key: 'descriptionTitle',
    defaultValue: "What's Included",
    type: 'textField'
  },
  {
    label: 'Display Original Price & Offer',
    key: 'showOfferPrice',
    type: 'toggle',
    defaultValue: true
  },
  {
    type: 'colorPicker',
    label: 'Button Color',
    key: 'buttonColor',
    darkKey: 'darkButtonColor'
  },
  {
    label: 'Loading Delay Message',
    type: 'quillEditor',
    defaultValue: 'Oops, it seems plans are taking longer than expected to load. Thank you for your patience!',
    key: 'loaderMessage',
    placeHolder: 'Oops, it seems plans are taking longer than expected to load. Thank you for your patience!'
  },
  { label: 'Separator', key: 'separatorShipping', type: 'separator' },
  { label: 'Shipping Form', type: 'fieldLabel', key: 'fieldLabelShipping' },
  {
    label:
      'Select the mandatory fields required for the shipping address from the options below. Unselected fields will still appear in the shipping address form, but they will not be mandatory.',
    type: 'hintText',
    key: 'shippingHint'
  },
  { label: 'Full Name', key: 'mandatoryFullName', type: 'checkbox', defaultValue: false },
  { label: 'Street Address', key: 'mandatoryStreetAddress', type: 'checkbox', defaultValue: false },
  { label: 'City', key: 'mandatoryCity', type: 'checkbox', defaultValue: false },
  { label: 'State', key: 'mandatoryState', type: 'checkbox', defaultValue: false },
  { label: 'Country', key: 'mandatoryCountry', type: 'checkbox', defaultValue: false },
  { label: 'Pin', key: 'mandatoryPin', type: 'checkbox', defaultValue: false },
  { label: 'Phone Number', key: 'mandatoryPhone', type: 'checkbox', defaultValue: false },
  { label: 'Email Address', key: 'mandatoryEmail', type: 'checkbox', defaultValue: true },
  { label: 'Separator', key: 'separatorThankYou', type: 'separator' },
  { label: 'Thank You Page', type: 'fieldLabel', key: 'fieldLabelThankYou' },
  {
    label: 'Title',
    type: 'quillEditor',
    defaultValue: 'Subscription Successful',
    key: 'thankYouPageTitle',
    placeHolder: ''
  },
  {
    label: 'Description',
    type: 'quillEditor',
    defaultValue:
      'Your subscription is active. Just log in or create your account to start enjoying your premium content.',
    key: 'thankYouPageDescription',
    placeHolder: ''
  },
  {
    label: 'Continue Button',
    placeHolder: 'Continue to Sign In / Sign Up',
    key: 'continueReading',
    defaultValue: 'Continue to Sign In / Sign Up',
    type: 'textField'
  }
];
